<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-15 11:29:13
 * @Description: K 考核项的，首页
-->
<template>
    <div class="container">
        <div class="head">
            <div class="title">
                <div class="text">{{ assessName }}</div>
                <div class="flex-row f-s-s mt-8 text-14 text-[#999999]">
                    <span> {{ areaName }}</span>
                    <span class="ml-8">{{ quarterName }}</span>
                </div>
            </div>
            <div class="rules">
                <div v-if="Number(ls_deduction) == 0" class="no-de">未扣分</div>
                <div v-else class="branch">-{{ ls_deduction }} {{  }}</div>
                <div class="num">{{ ls_score }}/{{ ls_sumScore }}</div>
            </div>
        </div>
        <!-- 列表  -->
        <template v-if="recordList && recordList.length > 0">
            <div class="card-bg mt-16 mx-12">
                <div class="flex flex-row mt-16 px-12 pb-12" v-for="(item, index) in recordList" :key="index"
                    :style="index != recordList.length - 1 ? 'border-bottom: 1px #EEEEEE solid' : ''">
                    <!-- left -->
                    <div class="flex-1 flex flex-col ">
                        <div class="text-16 text-[#333333] font-bold">{{ item.projectname }}</div>
                        <div class="mt-16 text-14 text-grey-b font-400">
                            <div v-if="item.type == 'K1' && item.percentage">
                                <div >{{ item.subtitle }} : {{ item.percentage }}% </div>  
                            </div>
                            <div v-if="item.type == 'K2'"> 
                                <p>游客满意率：{{ getSatisfactionStr(item) }} </p> 
                                <p class="mt-8">诱导、强迫游客取消退货数量：{{ getForceInduceRefundDeductionStr(item) }}</p>   
                            </div>
                            <span v-if="item.type == 'K3'"> {{ item.subtitle }} : {{ item.complainNumber}}件</span>
                        </div>
                        <div class="mt-16 text-[#36b374] flex items-center  w-180 h-12" @click="queryMore(item)">
                            <div class="">查看详情</div>
                            <img src="../../../assets/image/tb-right.png" class="object-contain size-10" />
                        </div>
                    </div>
                    <!-- right -->
                    <div class=" flex flex-col items-center">
                        <div class="text-[#FF4D4D] font-bold text-12 leading-12" >
                            <span >-{{ item.deduction / 100 }}分</span>
                        </div>
                        <div class="text-[#FF4D4D] font-bold text-12 leading-12"
                            v-if=" (item.type == 'K3' && item.complainNumber >= 10)">
                            已达扣分上限
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <!-- 没有扣分记录提示 -->
        <div v-else class="noData-bg">
            <nodata :noData="noData"></nodata>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nodata from "../components/nodata"; // 没有数据
import deducList from "./components/deducList"; // 扣分列表

import API from "@/service/index";
import commonAPI from "../../../utils/common";

export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
        nodata,
        deducList,
    },
    name: 'kCategoryIndex',
    props: {

    },
    data() {
        // 这里存放数据
        return {
            assessName: this.$route.query.assessName,
            noData: {
                title: "暂无数据",
            },
            recordList: [],
            asscessType: "",
            ls_deduction: 0,
            ls_sumScore: 0,
            ls_score: 0,
            year: this.$route.query.year,
            quarter: this.$route.query.quarter,
            area: this.$route.query.area,
            areaName: this.$route.query.areaName,
            quarterName: this.$route.query.quarterName,
        };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        getdeductionList(year, quarter, area) {
            API.getRefundScore({ year, quarter, area }).then((res) => {
                console.log("-----列表:", res);
                if (res.ret == 0) {
                    // this.recordList = res.data.list;
                    this.ls_deduction = res.data ? (res.data.deduction / 100).toFixed(2) : 0;
                    this.ls_sumScore = res.data ? (res.data.totalScore / 100).toFixed(1) : 0;
                    this.ls_score = (this.ls_sumScore - this.ls_deduction).toFixed(2);


                    //K1 web 字段 respoutNum b1
                    let refundPublicity = {
                        ...res.data.refundPublicity,
                        projectname: "宣传工作情况",
                        subtitle: "完成率",
                        type: "K1",
                    }
                    //K2
                    let refund = {
                        ...res.data.refund,
                        projectname: "办理退货情况",
                        subtitle: "游客满意率",
                        type: "K2",

                    }
                    // K3 
                    let refundComplain = {
                        ...res.data.refundComplain,
                        projectname: "游客投诉情况",
                        subtitle: "退货引发游客投诉",
                        type: "K3",
                    }
                    this.recordList = [refundPublicity, refund, refundComplain]
                }
            });
        },

        queryMore(value) {
            let params = {
                year: this.year,
                quarter: this.quarter,
                area: this.area,
                areaName:this.areaName,
                quarterName: this.quarterName,
            }
            this.$router.push({ path: '/appraise/kCategoryDetail', query: { ...value, dealType: value.type, ...params } });
        },
        getSatisfactionStr(item){
            if (item.satisfactionDeduction == 0 ) {
                return  `${item.satisfaction},不扣分`
            }
            return `${item.satisfaction},扣${(item.satisfactionDeduction/100).toFixed(1)}分`
        },
        getForceInduceRefundDeductionStr(item){
            if (item.forceInduceRefundDeduction == 0 ) {
                return  `${item.forceInduceRefundNumber}起,0扣分`
            }
            return `${item.forceInduceRefundNumber}起，扣${(item.forceInduceRefundDeduction/100).toFixed(1)}分${item.forceInduceRefundDeduction>=100?'（已达扣分上限）':''}`
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log('output->[ created ] >', this.$route.query)
        this.getdeductionList(this.year, this.quarter, this.area)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//  @import url(); 引入公共css类
.card-bg {
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding-bottom: 12px;
}

.container {
    min-height: 100vh;
    background: #fbfbfb;
    display: flex;
    flex-direction: column;
    position: relative;

    .noData-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }

    .head {
        background: #fff;
        padding: 20px 12px;
        display: flex;
        justify-content: space-between;

        .title {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 50px;

            .text {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 28px;
            }

            .tit {
                position: relative;
                display: flex;
                color: #999;
                font-size: 12px;
                margin-top: 12px;

                span {
                    position: relative;
                    padding-right: 16px;
                }

                span::after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 12px;
                    height: 12px;
                    background: url(../../../assets/image/t-right.png) no-repeat;
                    background-size: 12px 12px;
                }
            }
        }

        .rules {
            display: flex;
            flex-direction: column;
            color: #666666;
            text-align: right;

            .num {
                color: #999999;
                font-size: 14px;
                margin-top: 8px;
            }

            .branch {
                height: 22px;
                font-size: 22px;
                // font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: rgba(255, 77, 77, 1);
                line-height: 28px;
            }

            .no-de {
                min-width: 60px;
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #999;
                line-height: 22px;
            }
        }
    }
}
</style>